import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import {
  assignPermissionsToRole,
  createNewRole,
  deleteARole,
  updateARole,
} from '../../../../../api/user/update-role'

export const initialState = {
  updateRoleError: null,
  isUpdatingRole: false,
}

export const createRole = createAsyncThunk(
  'roleManagement/createRole',
  async (args, { rejectWithValue }) => {
    try {
      const { role, application, permissions } = args
      const response = await createNewRole({ role, application })
      await assignPermissionsToRole({ roleName: role.roleName, application, permissions })
      return response?.data?.data?.roles
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

export const updateRole = createAsyncThunk(
  'roleManagement/updateRole',
  async (args, { rejectWithValue }) => {
    try {
      const { role, application, permissions } = args
      const response = await updateARole({ role, application })
      await assignPermissionsToRole({ roleName: role.roleName, application, permissions })
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

export const deleteRole = createAsyncThunk(
  'roleManagement/deleteRole',
  async (args, { rejectWithValue }) => {
    try {
      const { role, application } = args
      const response = await deleteARole({ role, application })
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const updateRoleSlice = createSlice({
  name: 'updateRole',
  initialState,
  reducers: {
    resetUpdateRoleState: (state) => {
      state.isUpdatingRole = false
      state.updateRoleError = null
    },
  },
  extraReducers: (builder) => {
    builder
      // Creating Role
      .addCase(createRole.pending, (state) => {
        state.isUpdatingRole = true
        state.updateRoleError = null
      })
      .addCase(createRole.fulfilled, (state) => {
        state.isUpdatingRole = false
        state.updateRoleError = null
      })
      .addCase(createRole.rejected, (state, action) => {
        state.isUpdatingRole = false
        state.updateRoleError = action.payload
      })
      // Updating Role
      .addCase(updateRole.pending, (state) => {
        state.isUpdatingRole = true
        state.updateRoleError = null
      })
      .addCase(updateRole.fulfilled, (state) => {
        state.isUpdatingRole = false
        state.updateRoleError = null
      })
      .addCase(updateRole.rejected, (state, action) => {
        state.isUpdatingRole = false
        state.updateRoleError = action.payload
      })
      // Deleting Role
      .addCase(deleteRole.pending, (state) => {
        state.isUpdatingRole = true
        state.updateRoleError = null
      })
      .addCase(deleteRole.fulfilled, (state) => {
        state.isUpdatingRole = false
        state.updateRoleError = null
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.isUpdatingRole = false
        state.updateRoleError = action.payload
      })
      /* Action which gets triggered
         when running persistor.purge() */
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export const { resetUpdateRoleState } = updateRoleSlice.actions

export default updateRoleSlice.reducer
